  // For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
  $w("#button20").onClick(() => {
    $w('#statebox16').changeState("Overview");
  } );
  $w("#button19").onClick(() => {
    $w('#statebox16').changeState("Itinerary");
  } );
  $w("#button18").onClick(() => {
    $w('#statebox16').changeState("TourRequirements");
  } );
  $w("#button21").onClick(() => {
    $w('#statebox16').changeState("FAQ");
  } );
})

export function statebox8_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}
